export {default as path} from "./path.js";



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-path/src/index.js
// module id = 2zaW
// module chunks = 0